import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Logo from "./Assets/Brand/logo.png";
import "./App.css";
import FormOne from "./Components/Form01";
import FormTwo from "./Components/Form02";

function App() {
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (!JSON.parse(localStorage.getItem("ClientData"))) {
      setPage(1);
    } else {
      setPage(2);
    }
  }, []);

  const MoveToPage = (data) => {
    if (data === 2) {
      if (JSON.parse(localStorage.getItem("ClientData"))) {
        setPage(data);
      }
    } else {
      setPage(data);
    }
  };
  return (
    <div className="App">
      <Container fluid className="Page_Header">
        <Container className="Page_Container">
          <img src={Logo} alt="logo" className="Header_logo" />
          <h3 className="Page_Header_Text">MILLGATE BOOKING SCHEME</h3>
        </Container>
      </Container>
      <Container fluid>
        <Container>
          <Row>
            <Col xxl={8}>
              <div className="Stage_Box">
                <div className={`Stage ${page === 1 ? "Active" : ""}`}>
                  <span>1</span>
                </div>
                <div className={`Stage ${page === 2 ? "Active" : ""}`}>
                  <span>2</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid>
        <Container>
          <Row>
            {page === 1 ? (
              <FormOne GetToNextPage={MoveToPage} />
            ) : (
              <FormTwo GetToNextPage={MoveToPage} />
            )}
            <Col xxl={4}></Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default App;
